<script>
import baseEdit from "@/views/components/base/baseEdit.vue";

export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "consumables",
      key: "id",
      url: {
        get: "/admin/system/inventory/getInfo",
        add: "/admin/system/inventory",
        edit: "/admin/system/inventory",
      },
      items: [
        { label: "新增耗材", type: "header" },
        {
          label: "图片",
          name: "consumableImgUrl",
          value: "",
          type: "avatar",
          desc: "建议图片宽高尺寸512*512像素及以上",
          rules: [{ required: false, trigger: "blur" }],
        },
        {
          label: "名称",
          name: "name",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "分类",
          name: "typeId",
          value: "",
          width: "400px",
          type: "select",
          dropList: [],
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        {
          label: "数量",
          name: "num",
          value: 1,
          type: "number",
          width: "200px",
          min: 0,
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        {
          label: "型号",
          name: "model",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "品牌",
          name: "brand",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "领用状态",
          name: "receiveState",
          value: 1,
          width: "400px",
          type: "select",
          dropList: [
            { name: "目录内物资-30分钟内派送", value: 1 },
            { name: "目录外申请", value: 2 },
          ],
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        { label: "适用于", name: "remark", value: "", type: "input", width: "400px" },
        {
          label: "性能参数",
          name: "performanceParameter",
          value: "",
          type: "input",
          width: "400px",
        },
        // {
        //   label: "产品条码",
        //   name: "productBarcode",
        //   value: "",
        //   type: "input",
        //   width: "400px",
        // },
        {
          label: "备注(可填写网址)",
          name: "remark1",
          value: "",
          type: "input",
          width: "400px",
        },
        {
          label: "单位",
          name: "unit",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "进货价",
          name: "jdPrice",
          value: 1,
          type: "number",
          width: "200px",
          min: 0,
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        {
          label: "单价",
          name: "unitPrice",
          value: 1,
          type: "number",
          width: "200px",
          min: 0,
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
      ],
      forms: {},
    };
  },
  created() {
    let query = this.$route.query;
    if (query.action == "edit") {
      this.initData();
    }
    this.loadLevelData();
  },
  methods: {
    loadLevelData() {
      let q = {};
      $utils.api.load("/admin/system/consumableType/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.model;
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "typeId") {
              this.items[index]["dropList"] = dropList;
            }
          }
        }
      });
    },
  },
};
</script>
